import { EntityView } from '@/common/entityFramework/entityView/EntityView';
import { Route } from 'react-router-dom';

const ucbScRoutes = [<Route path="/sc/mcd-ledger-line" element={<EntityView />} />];

export default ucbScRoutes;
